import * as Ktrace from '@ktrace/web';
import { inBrowser } from '@utils';
import config from "../../../appConfig";

function ktraceInit() {
    Ktrace.init(config.ktraceConfig);
}
// 此处为对标 weblog 的引入，否则初始化方法会在 weblog 后执行
if (inBrowser) {
    ktraceInit();
}

export default Ktrace;
